import { useMemo } from 'react';
import { ExchangeableSuccess, Refundable } from '../Icons';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
export const useFlightInfoCardControls = (order) => {
    const history = useHistory();
    const { t } = useTranslation('FlightInfoCard');
    const controls = useMemo(() => {
        var _a, _b, _c, _d;
        const controls = [];
        if (((_a = order.exareInfo) === null || _a === void 0 ? void 0 : _a.isExchangeVariantsAvailable) || !!((_b = order.exareInfo) === null || _b === void 0 ? void 0 : _b.lastExchange)) {
            controls.push({
                icon: ExchangeableSuccess,
                name: t('Change'),
                onClick: () => {
                    history.push(`exchange`);
                }
            });
        }
        if (((_c = order.exareInfo) === null || _c === void 0 ? void 0 : _c.isGetRefundInfoAvailable) || ((_d = order.exareInfo) === null || _d === void 0 ? void 0 : _d.refundAvailability)) {
            controls.push({
                icon: Refundable,
                name: t('Refund'),
                onClick: () => {
                    history.push(`refund`);
                }
            });
        }
        return controls;
    }, [order, history]);
    return controls;
};
